const MIN_RATING = 2.0;
const MAX_RATING = 8.0;
const BAND_WIDTH = 0.5;
export const COARSE_RATING_STYLE = "band";
export const DUPR_RATING_DECIMALS = 2;
export function roundDuprRating(rating) {
    const factor = 10 ** DUPR_RATING_DECIMALS;
    return Math.round(rating * factor) / factor;
}
const NO_RATING = "—";
export function formatDuprRating(rating, { placeholder = NO_RATING, signed = false } = {}) {
    if (rating === null || rating === undefined)
        return placeholder;
    let value;
    if (typeof rating === "string") {
        const trimmed = rating.trim();
        if (trimmed === "")
            return placeholder;
        value = Number(trimmed);
        if (!Number.isFinite(value))
            return trimmed;
    }
    else {
        if (!Number.isFinite(rating))
            return placeholder;
        value = rating;
    }
    const text = value.toFixed(DUPR_RATING_DECIMALS);
    return signed && value > 0 ? `+${text}` : text;
}
function roundToDisplayed(rating) {
    return roundDuprRating(rating);
}
function clamp(rating) {
    return Math.min(MAX_RATING, Math.max(MIN_RATING, rating));
}
function assertFinite(rating) {
    if (!Number.isFinite(rating)) {
        throw new Error(`Cannot derive a coarse rating label from a non-finite value: ${String(rating)}`);
    }
}
export function ratingBand(rating) {
    assertFinite(rating);
    const value = clamp(roundToDisplayed(rating));
    const lower = Math.floor(value / BAND_WIDTH) * BAND_WIDTH;
    if (lower >= MAX_RATING - BAND_WIDTH) {
        return `${(MAX_RATING - BAND_WIDTH).toFixed(1)}+`;
    }
    return `${lower.toFixed(1)}-${(lower + BAND_WIDTH).toFixed(1)}`;
}
export function ratingTier(rating) {
    assertFinite(rating);
    const value = clamp(roundToDisplayed(rating));
    if (value >= 5.0)
        return "Competitive";
    if (value >= 4.0)
        return "Advanced";
    if (value >= 3.0)
        return "Intermediate";
    return "Beginner";
}
export function coarseRatingLabel(rating) {
    return COARSE_RATING_STYLE === "band"
        ? ratingBand(rating)
        : ratingTier(rating);
}
export function isDuprRated(value) {
    const trimmed = value?.trim() ?? "";
    return trimmed !== "" && Number.isFinite(Number(trimmed));
}
export function duprReliabilityPercent(reliability) {
    if (reliability === null || reliability === undefined)
        return null;
    if (!Number.isFinite(reliability))
        return null;
    return Math.min(100, Math.max(0, Math.round(reliability)));
}
export function formatDuprReliability(reliability) {
    const pct = duprReliabilityPercent(reliability);
    return pct !== null ? `${pct}%` : null;
}
